import { Component, computed, input } from '@angular/core';
import { IconComponent } from '../icon/icon';

export type EmptyStateSize = 'sm' | 'md' | 'lg';

const sizes: Record<EmptyStateSize, string> = {
  sm: 'min-h-24',
  md: 'min-h-36',
  lg: 'min-h-48',
};

const defaultSize: EmptyStateSize = 'md';

@Component({
  selector: 'wma-empty-state',
  templateUrl: 'empty-state.html',
  imports: [IconComponent],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class EmptyStateComponent {
  /** The name of the icon displayed above the message. */
  icon = input('inbox');
  /** The minimum height of the empty state. */
  size = input<EmptyStateSize>();

  /* The CSS classname applied to the host element. */
  hostClasses = computed(() => {
    return `flex flex-col items-center justify-center text-center ${sizes[this.size() || defaultSize]}`;
  });
}
